import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Divider,
  useTheme,
  ToggleButton,
  ToggleButtonGroup,
  Link,
  InputAdornment,
} from "@mui/material";
import {
  ArrowBack,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomTextField from "../components/RTLTextField";
import { useDispatch } from "react-redux";
import { changepassword } from "../redux/slices/user/thunk";

const SetPasswordScreen = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const user = location?.state?.user;
  console.log("user",user);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { t , i18n } = useTranslation();
  const isRtl = i18n.language == 'ar'

  // Form validation schema
  const validationSchema = Yup.object({
    password: Yup.string()
      .min(6, t("validation.passwordMin"))
      .required(t("validation.passwordRequired")),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], t("validation.passwordsMustMatch"))
      .required(t("validation.confirmPasswordRequired")),
  });

  // Formik configuration
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try{

        const id = user?._id
        const data = {
          // email:email,
          newPassword:values.password
        }
        const response = await dispatch(changepassword({data, id}))
        if(user?._id){
          localStorage.setItem('user', JSON.stringify(user));
        }
        if(user.type == 'admin'){
          return navigate('/adminHome')
        }
        if(user.type == 'family'){
          return navigate('/familyHome')
        }
        if(user.type == "client"){
          return navigate('/home')
        }
        console.log("response",response);
      }catch(error){
        console.log("error",error);
      }
      console.log("set password form submitted:", values);
      // Add your sign up logic here
    },
  });

  let SetPasswordImage;
  try {
    SetPasswordImage = require("../assets/Logo.png");
  } catch (error) {
    SetPasswordImage = null;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Grid
        container
        spacing={0}
        sx={{
          borderRadius: 4,
          overflow: "hidden",
          boxShadow: 3,
          border: "1px solid #d0d0d0",
        }}
      >
        {/* Left Column - Login Form */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            backgroundColor: theme.palette.primary.mainLoginBackground,
            py: 6,
            px: { xs: 3, md: 6 },
          }}
        >

                      {/* Back to Login Link */}
                      <Link
                        href="/login"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 3,
                          color: theme.palette.blackandWhite.main,
                          textDecoration: "none",
                          fontWeight: 500,
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        <ArrowBack sx={{ mr: 1 }} />
                        {t("Back to login")}
                      </Link>
          


          <Box sx={{ maxWidth: 500, mx: "auto" }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 700,
                mb: 1,
                color: theme.palette.blackandWhite.main,
              }}
            >
              {t("Set a password")}
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: 4,
                color: theme.palette.text.secondary,
              }}
            >
              {t("passwordResetSuccess")}
            </Typography>

            {/* Login Form */}
            <form onSubmit={formik.handleSubmit}>
              {/* Password Field */}
              <CustomTextField
                fullWidth
                id="password"
                name="password"
                label={t("Password")}
                type={showPassword ? "text" : "password"}
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  ),
                }}
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    backgroundColor:
                      theme.palette.primary.mainTextFieldBackground,
                  },
                }}
                isRtl={isRtl}
              />
              {/* Confirm Password Field */}
              <CustomTextField
                fullWidth
                id="confirmPassword"
                name="confirmPassword"
                label={t("Confirm Password")}
                type={showConfirmPassword ? "text" : "password"}
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.confirmPassword &&
                  Boolean(formik.errors.confirmPassword)
                }
                helperText={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: 2,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    backgroundColor:
                      theme.palette.primary.mainTextFieldBackground,
                  },
                }}
                 isRtl={isRtl}
              />

              {/* Login Button */}
              <Button
                fullWidth
                variant="contained"
                type="submit"
                sx={{
                  py: 1.5,
                  mb: 3,
                  fontWeight: 600,
                  fontSize: "1rem",
                  borderRadius: "8px",
                }}
              >
                {t("Set a password")}
              </Button>
            </form>
          </Box>
        </Grid>

        {/* Right Column - Login Image */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
          }}
        >
          {SetPasswordImage ? (
            <img
              src={SetPasswordImage}
              alt="Login"
              style={{
                width: "50%",
                // height: "200px",
                objectFit: "cover",
                display: "block",
              }}
            />
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                minHeight: 500,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" color="textSecondary">
                Login Image Placeholder
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default SetPasswordScreen;
